export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://cdn-fonts.severance.workers.dev","crossorigin":""},{"rel":"preload","href":"https://cdn-fonts.severance.workers.dev/ClashDisplay-Extralight.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"https://cdn-fonts.severance.workers.dev/ClashDisplay-Light.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"https://cdn-fonts.severance.workers.dev/ClashDisplay-Regular.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"https://cdn-fonts.severance.workers.dev/ClashDisplay-Medium.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"https://cdn-fonts.severance.workers.dev/ClashDisplay-Semibold.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"https://cdn-fonts.severance.workers.dev/ClashDisplay-Bold.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"preload","as":"style","href":"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap","media":"print","onload":"this.media='all'"}],"style":[],"script":[{"innerHTML":"let FF_FOUC_FIX;","type":"text/javascript"}],"noscript":[{"children":"<link rel=\"stylesheet\" href=\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap\" />"}],"title":"Boosting Market"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false